"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagES = function FlagES(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94,146.36H209.54a7.07,7.07,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.06,7.06,0,0,0,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "57.5",
    width: "409.6",
    height: "155.37",
    fill: "#ffd250"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20,12.18l6-26.95a4,4,0,0,0-3.88-4.83h-4.22A4,4,0,0,0-26-14.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "166.96",
    y: "121.05",
    width: "14.13",
    height: "60.02",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "163.43",
    y: "114",
    width: "21.18",
    height: "7.06",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "149.3",
    y: "135.18",
    width: "35.31",
    height: "7.06",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.39,40.43l-21.18-7.06V26.3l21.18,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-125.91,12.18l6-26.95a4,4,0,0,0-3.88-4.83H-128a4,4,0,0,0-3.88,4.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.19-9a7.07,7.07,0,0,0-7.06,7.06V44c0,8.58,8,24.72,35.3,24.72S-37.63,52.54-37.63,44V-1.95A7.07,7.07,0,0,0-44.7-9Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95,26.3h-35.3V-1.95A7.07,7.07,0,0,1-101.19-9h28.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95,26.3h35.32V44A17.66,17.66,0,0,1-55.29,61.61,17.66,17.66,0,0,1-72.95,44Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-108.25,26.3h35.3V44A17.65,17.65,0,0,1-90.6,61.61,17.65,17.65,0,0,1-108.25,44Zm0,0",
    transform: "translate(194 123)",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80,58V26.3h-7.06v35A17.39,17.39,0,0,0-80,58Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-94.13,61.26v-35h-7.07V58a17.49,17.49,0,0,0,7.07,3.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "92.81",
    y: "135.18",
    width: "21.19",
    height: "7.06",
    fill: "#ffb441"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "92.81",
    y: "121.05",
    width: "21.19",
    height: "7.06",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "96.34",
    y: "125.25",
    width: "14.13",
    height: "12.79",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "61.02",
    y: "121.05",
    width: "14.13",
    height: "60.02",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "57.5",
    y: "177.55",
    width: "21.19",
    height: "7.06",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "57.5",
    y: "114",
    width: "21.19",
    height: "7.06",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "53.97",
    y: "184.61",
    width: "28.25",
    height: "7.06",
    fill: "#5064aa"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "166.96",
    y: "177.55",
    width: "21.18",
    height: "7.06",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "159.89",
    y: "184.61",
    width: "28.25",
    height: "7.06",
    fill: "#5064aa"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "99.87",
    y: "106.93",
    width: "42.38",
    height: "7.06",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "117.53",
    y: "85.75",
    width: "7.06",
    height: "21.19",
    fill: "#ffb441"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80-26.66A10.6,10.6,0,0,1-90.6-37.25,10.6,10.6,0,0,1-80-47.85a10.61,10.61,0,0,1,10.6,10.6A10.6,10.6,0,0,1-80-26.66Zm0-14.13a3.54,3.54,0,0,0-3.53,3.54A3.54,3.54,0,0,0-80-33.72a3.54,3.54,0,0,0,3.53-3.53A3.54,3.54,0,0,0-80-40.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.88-26.66a10.61,10.61,0,0,1-10.6-10.59,10.61,10.61,0,0,1,10.6-10.6,10.61,10.61,0,0,1,10.59,10.6A10.6,10.6,0,0,1-65.88-26.66Zm0-14.13a3.54,3.54,0,0,0-3.53,3.54,3.54,3.54,0,0,0,3.53,3.53,3.54,3.54,0,0,0,3.53-3.53,3.54,3.54,0,0,0-3.53-3.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-51.76-19.6A10.6,10.6,0,0,1-62.35-30.19a10.6,10.6,0,0,1,10.59-10.6,10.62,10.62,0,0,1,10.6,10.6A10.61,10.61,0,0,1-51.76-19.6Zm0-14.12a3.53,3.53,0,0,0-3.53,3.53,3.53,3.53,0,0,0,3.53,3.53,3.53,3.53,0,0,0,3.53-3.53,3.53,3.53,0,0,0-3.53-3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-94.13-19.6a10.6,10.6,0,0,1-10.59-10.59,10.6,10.6,0,0,1,10.59-10.6,10.61,10.61,0,0,1,10.59,10.6A10.6,10.6,0,0,1-94.13-19.6Zm0-14.12a3.53,3.53,0,0,0-3.53,3.53,3.53,3.53,0,0,0,3.53,3.53,3.53,3.53,0,0,0,3.53-3.53,3.53,3.53,0,0,0-3.53-3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-51.76,40.43V44a3.53,3.53,0,0,1-3.53,3.53A3.53,3.53,0,0,1-58.82,44V40.43h7.06m7.06-7.06H-65.88V44A10.6,10.6,0,0,0-55.29,54.55,10.6,10.6,0,0,0-44.7,44V33.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-55.29,19.24a7.06,7.06,0,0,1-7.06-7.06V5.12a7.07,7.07,0,0,1,7.06-7.07,7.07,7.07,0,0,1,7.06,7.07v7.06a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffa0d2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62.35,26.3a10.59,10.59,0,0,1-10.6,10.59A10.59,10.59,0,0,1-83.54,26.3,10.59,10.59,0,0,1-72.95,15.71,10.59,10.59,0,0,1-62.35,26.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#5064aa"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "117.53",
    y: "71.62",
    width: "7.06",
    height: "21.18",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-94.13-16.07l-7.07-7.06,4.14-4.14a34.12,34.12,0,0,1,24.11-10,34.13,34.13,0,0,1,24.12,10l4.13,4.14-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69.41-23.13a3.53,3.53,0,0,1-3.54,3.53,3.53,3.53,0,0,1-3.53-3.53,3.53,3.53,0,0,1,3.53-3.53,3.53,3.53,0,0,1,3.54,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd250"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.54-23.13a3.53,3.53,0,0,1-3.53,3.53,3.53,3.53,0,0,1-3.53-3.53,3.53,3.53,0,0,1,3.53-3.53,3.53,3.53,0,0,1,3.53,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd250"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-55.29-23.13a3.54,3.54,0,0,1-3.53,3.53,3.53,3.53,0,0,1-3.53-3.53,3.53,3.53,0,0,1,3.53-3.53,3.54,3.54,0,0,1,3.53,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd250"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "57.5",
    y: "135.18",
    width: "35.31",
    height: "7.06",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-136.5,40.43l21.18-7.06V26.3l-21.18,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagES;
exports["default"] = _default;